import { View } from 'react-native';
const ScreenFooter = View;
const FooterComponent = View;
export default ScreenFooter;
export { FooterComponent };
//# sourceMappingURL=ScreenFooter.web.js.map